import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appfile-ionic',
  templateUrl: './appfile-ionic.component.html',
  styleUrls: ['./appfile-ionic.component.scss'],
})
export class AppfileIonicComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
